import GeometryFactory from 'jsts/org/locationtech/jts/geom/GeometryFactory';
import Coordinate from 'jsts/org/locationtech/jts/geom/Coordinate';
import Polygon from 'jsts/org/locationtech/jts/geom/Polygon';
import LinearRing from 'jsts/org/locationtech/jts/geom/LinearRing';
import { ApiPoint } from 'src/components/viewers/SheetsViewerV2/utils/apiCoordinatesConverter';

type SupportedPoint = THREE.Vector3 | ApiPoint;

export const toJstsCoordinate = (point: SupportedPoint) =>
  new Coordinate(point.x, point.y);

export function isPointWithinPolygon(polygon: Polygon, point: Coordinate) {
  let isWithin = false;
  const ring = polygon.getCoordinates();
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const xi = ring[i].x;
    const yi = ring[i].y;
    const xj = ring[j].x;
    const yj = ring[j].y;
    const intersect =
      yi > point.y !== yj > point.y &&
      point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi;
    if (intersect) isWithin = !isWithin;
  }

  return isWithin;
}

export function areAllPointsInsidePolygon(
  polygon: Polygon,
  container: Polygon
) {
  const coordinates = polygon.getExteriorRing().getCoordinates();

  return coordinates.every((coordinate) =>
    isPointWithinPolygon(container, coordinate)
  );
}

export function mapPointsToMultiPolygons(rings: SupportedPoint[][]) {
  const geometryFactory = new GeometryFactory();
  const polygons = rings
    .map((points) =>
      geometryFactory.createPolygon(points.map(toJstsCoordinate))
    )
    .sort((a, b) => b.getArea() - a.getArea());
  const grouped: { exterior: Polygon; interiors: LinearRing[] }[] = [];

  for (let i = 0; i < polygons.length; i++) {
    const polygon = polygons[i];
    let parentGroup = null;

    for (const group of grouped) {
      if (areAllPointsInsidePolygon(polygon, group.exterior)) {
        parentGroup = group;
        break;
      }
    }

    if (parentGroup) {
      parentGroup.interiors.push(polygon.getExteriorRing());
    } else {
      grouped.push({ exterior: polygon, interiors: [] });
    }
  }

  const polygonsWithHoles: Polygon[] = grouped.map((group) => {
    const shell = group.exterior.getExteriorRing();
    return geometryFactory.createPolygon(shell, group.interiors);
  });

  return geometryFactory.createMultiPolygon(polygonsWithHoles);
}
